module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Bed-7d8a0815a24e3fcdc9e8ab1910562e28f2647e9893917c4e5d5185373a78970f.svg";